import React, { Component } from "react";
import { AiOutlineLogout, AiOutlineMenu, AiFillWarning } from "react-icons/ai";
import { GiTwoCoins, GiShoppingCart } from "react-icons/gi";
import { MdOutlineDesignServices, MdPrivacyTip, MdEmail } from "react-icons/md";
// import { TiDeleteOutline } from "react-icons/ti";
import { GiMagicSwirl } from "react-icons/gi";
import { IoMdImages } from "react-icons/io";
import { FaQuestionCircle } from "react-icons/fa";
import "./Header.css";
import { Link } from "react-router-dom";
import { FAQ } from "./Tutorials";

class Header extends Component {

    state = {
        faq: false,
    }

    logout = () => {
        this.props.auth0.logout({ returnTo: window.location.origin })
    }
    handlePrivacyPolicy = () => {
        this.props.history.push("/privacy-policy");
    }

    handleTermsOfService = () => {
        this.props.history.push("/terms-of-service");

    }

    delete = async () => {
        const result = window.confirm("Are you sure that you want to delete your account? All your images and post will be deleted and you will lose any unused credits.")
        if (result) {
            await this.props.deleteAccount();
        }
    }

    render() {
        // const w = window.innerWidth;
        const iconSize = "25"
        const loc = this.props.history.location.pathname;
        return (
            <div className="header">
                <div style={{ height: "100%", display: "flex", justifyItems: "center", alignItems: "center" }} >
                    <img
                        className="header-logo"
                        src={"./logo_512.png"}
                        alt="Artblast AI logo" />

                </div>
                <div style={{ height: "100%", display: "flex", justifyItems: "center", alignItems: "center" }}>

                    {loc === "/feed" &&
                        <Link to="/generate" style={{ textDecoration: "none" }}><div className="button-link-main"><GiMagicSwirl size={22} style={{ verticalAlign: "middle" }} />{" Create"}</div></Link>
                    }
                    {loc === "/generate" &&
                        <Link to="/feed" style={{ textDecoration: "none" }}><div className="button-link-main"><IoMdImages size={22} style={{ verticalAlign: "middle" }} />{" Showcase"}</div></Link>
                    }

                    <div className="dropdown">

                        <AiOutlineMenu size={iconSize} className="button-link" style={{ verticalAlign: "middle" }} />
                        <div className="dropdown-content">
                            <div className="dropdown-item"><p><MdEmail size={20} className="react-icons" />{`${this.props.email.slice(0, 20)}`}</p></div>
                            <div className="dropdown-item"><p><GiTwoCoins size={20} className="react-icons" />{`Credits: ${this.props.credits}`}</p></div>
                            <div className="dropdown-item" onClick={() => { this.props.setPurchaseModal(true) }}><p><GiShoppingCart size={20} className="react-icons" />{`Purchase Credits`}</p></div>
                            <div className="dropdown-item" onClick={this.handlePrivacyPolicy}><MdPrivacyTip size={20} className="react-icons" />{`Privacy Policy`}</div>
                            <div className="dropdown-item" onClick={this.handleTermsOfService}><MdOutlineDesignServices size={20} className="react-icons" />{`Terms of service`}</div>
                            <div className="dropdown-item" onClick={() => this.setState({ faq: true })}><FaQuestionCircle size={20} className="react-icons" />{`Help/FAQ`}</div>
                            <div className="dropdown-item" onClick={() => this.logout()}><AiOutlineLogout size={20} className="react-icons" />{`Logout`}</div>
                            <div className="dropdown-item" onClick={() => this.delete()}><AiFillWarning size={20} className="react-icons" color="red" />{`Delete Account`}</div>
                        </div>

                    </div>
                </div>

                {this.state.faq &&
                    <FAQ close={() => { this.setState({ faq: false }) }} />
                }

            </div>
        );
    }
}

export default Header;